import type { StateCreator } from 'zustand'

import type { Workspace } from '../workspaces.type'

import type { WorkspacesActionsSlice, WorkspacesFetchPatch, WorkspacesStore } from './workspaces.type'

type WorkspacesSet = Parameters<StateCreator<WorkspacesStore, [['zustand/immer', never]], [], WorkspacesStore>>[0]

export const createWorkspacesSyncActions = (set: WorkspacesSet): WorkspacesActionsSlice => ({
  setState: (updateState: WorkspacesFetchPatch) => set((state) => ({ ...state, ...updateState })),
  setWorkspaces: (workspaces: Workspace[]) =>
    set((state) => {
      state.workspaces = workspaces
    }),
  setCurrentWorkspace: (workspace: Workspace | null) =>
    set((state) => {
      state.currentWorkspace = workspace
    }),
  setCreateProjectForWorkspaceId: (workspaceId: string | null) =>
    set((state) => {
      state.createProjectForWorkspaceId = workspaceId
    }),
  setLoading: (loading: boolean) =>
    set((state) => {
      state.loading = loading
    }),
  setError: (error: string | null) =>
    set((state) => {
      state.error = error
    }),
  setIsCreatingWorkspace: (value: boolean) =>
    set((state) => {
      state.isCreatingWorkspace = value
    }),
})
